import { z } from 'zod';

export const timeseriesAPISchema = z.object({
  id: z.number(),
  name: z.string(),
  sector: z.string(),
  sym_id: z.number(),
  symbol: z.string(),
  time_stamp: z.string(),
  data: z.string(),
});

export type TimeseriesAPISchema = z.infer<typeof timeseriesAPISchema>;

export const timeSeriesJSONSchema = z.array(z.array(z.number()).length(4));

export type TimeSeriesJSONSchema = z.infer<typeof timeSeriesJSONSchema>;

export const timeseriesSchema = timeseriesAPISchema.extend({
  data: z.array(
    z.object({
      date: z.date(),
      endValue: z.number(),
      volume: z.number(),
      startValue: z.number(),
    })
  ),
});

export type TimeseriesSchema = z.infer<typeof timeseriesSchema>;
